import { useEffect, useState } from "react";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useSelector } from "react-redux";
import { ClientAccountEmailModel } from "services/api/cplapi/CPLAPI";
import { OKAlert } from "cpl-react-common/components/Alerts/Okay";
import { Style } from "cpl-react-common/Helpers/AlertHelpers";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { selectClientID } from "../ContactDetailsSlice";
import {
  deleteClientEmailAddress,
  getClientEmailAddressDetails,
  selectClientEmailAddressDetails,
  selectLoadingClientEmailAddressDetails,
  updateClientEmailAddressDetails,
} from "./ClientEmailAddressesSlice";
import NewClientEmailModal from "./NewClientEmailModal";
import ClientEmailAddressDetails from "./ClientEmailAddressDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { selectGlobalSettings } from "app/modules/system/settings/ClientPortalSettingsSlice";

const ClientEmailAddressesList = () => {
  const thunkDispatch = useThunkDispatch();
  const clientID = useSelector(selectClientID);
  const loading = useSelector(selectLoadingClientEmailAddressDetails);
  const clientEmailAddresses = useSelector(selectClientEmailAddressDetails);
  const { showEmailAddressEdit } = useSelector(selectGlobalSettings);
  const canEdit = showEmailAddressEdit !== false;
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showNewEmailModal, setShowNewEmailModal] = useState(false);

  useEffect(() => {
    thunkDispatch(getClientEmailAddressDetails({ clientID: clientID }));
  }, [thunkDispatch, clientID]);

  function updateEmailAddressDetails(newEmailDetails: ClientAccountEmailModel) {
    thunkDispatch(updateClientEmailAddressDetails({ clientAccountEmailModel: newEmailDetails }));
  }

  function deleteEmailAddress(emailAddressDetails: ClientAccountEmailModel) {
    if (emailAddressDetails.default) {
      setShowDeleteAlert(true);
    } else {
      thunkDispatch(deleteClientEmailAddress({ clientAccountEmailID: emailAddressDetails.clientEmailID! }));
    }
  }

  return (
    <>
      <OKAlert
        showAlert={showDeleteAlert}
        alertText={"Cannot delete default email address. Please select a new default before deleting!"}
        alertTitle="Default email"
        callBack={() => setShowDeleteAlert(false)}
        style={Style.Danger}
      />
      <NewClientEmailModal
        ShowNewEmailModal={showNewEmailModal}
        DismissNewEmailModalCallback={() => setShowNewEmailModal(false)}
      />
      <div className="card">
        <div className="card-body">
          <div className="row mb-2">
            <div className="col-sm-8 col-md-9">
              <h2 className="heading-text">Email Addresses</h2>
            </div>
            <div className="col-sm-4 col-md-3 text-end">
              {canEdit && (
                <button
                  data-test-id="email-addresses-list__new-email-button"
                  className="cpl-btn cpl-btn-primary"
                  onClick={() => setShowNewEmailModal(true)}
                >
                  <span className="page-create-btn">
                    <FontAwesomeIcon icon={faPlus} className="pt-1" />
                  </span>
                  <span className="ms-2">New Email</span>
                </button>
              )}
            </div>
          </div>
          <ActivityIndicator isBusy={loading}>
            {clientEmailAddresses?.map((clientEmailAddress) => {
              return (
                <div key={clientEmailAddress.clientEmailID} className="border-top pb-2">
                  <ClientEmailAddressDetails
                    ClientEmailAddressDetails={clientEmailAddress}
                    UpdateClientEmailAddressDetailsCallback={updateEmailAddressDetails}
                    DeleteClientEmailAddressDetailsCallback={deleteEmailAddress}
                  />
                </div>
              );
            })}
          </ActivityIndicator>
        </div>
      </div>
    </>
  );
};

export default ClientEmailAddressesList;
